import React, { useEffect, useRef, useState, useContext } from "react";
import CampaignTracker from "./CampaignTracker";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Women from "../../images/LandingPageImage/Hero Section.webp";
import Women1 from "../../images/My-landing-img1.png";
import { Link, useNavigate } from "react-router-dom";
import grow2 from "../../images/LandingPageImage/Vector (1).png";
import grow3 from "../../images/LandingPageImage/Vector (2).png";
import grow1 from "../../images/LandingPageImage/Vector (3).png";
import qrImage from "../../images/LandingPageImage/chaafo_qr_code_demo.webp";
import { toast, ToastContainer } from "react-toastify";
import ExternalChatBot from "../Landing_Page/Home_Page/ChatBot";
import Campaign from "../../images/campaign_analytics_1x.webp";
import Order from "../../images/order_management_1x.webp";
import Team from "../../images/inbox_team_1x.webp";
import BroadCast from "../../images/broadcast_1x.webp";
import CreateSession from "./CreateSession";

import MyContext from "../../MyContext"; //using ContextAPI to store data dynamically
import BuiltForBusiness from "./BuiltForBusiness";
import "./MainLanding.css";
import LogoScroll from "./LogoScroll";
import FaqSection from "./FaqSection";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CtaSection from "./CtaSection";
import PricingSection from "./PricingSection";
import ContactSection from "./ContactSection";

function MyLanding({ onLoginClick }) {
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const homeRef = useRef(null);
  const demoVideoRef = useRef(null);
  const featuresRef = useRef(null);
  const industryRef = useRef(null);
  const businessgrowthRef = useRef(null);
  const pricingRef = useRef(null);
  const contactusRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [isAnnual, setIsAnnual] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [sessionID, setSessionId] = useState("");
  const [campaignIdHook, setCampaignIdHook] = useState("");
  const handleClose = () => setShowModal(false);

  const initialStepName = `${window.location.origin}/get#home`;
  const initialTimestamp = new Date()
    .toLocaleString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
    .replace(",", "")
    .replace(/\//g, "-")
    .replace(" ", " ")
    .slice(0, 19);
  const formattedTimestamp = initialTimestamp
    .split(" ")
    .map((part, index) => {
      if (index === 0) {
        // Reorder date to "YYYY-MM-DD"
        const dateParts = part.split("-");
        return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
      }
      return part; // Return time as is
    })
    .join(" ");

  // Initialize `currentArray` with the `#home` entry
  const [currentArray, setCurrentArray] = useState([
    { stepName: initialStepName, timestamp: formattedTimestamp },
  ]);
  const previousArrayRef = useRef([]);

  const generateUUID = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };
  useEffect(() => {
    let storedSessionID = sessionStorage.getItem("sessionID");
    if (storedSessionID) {
      setSessionId(storedSessionID);
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      let sessionIDFromUrl = urlParams.get("sessionID");

      if (sessionIDFromUrl) {
        sessionStorage.setItem("sessionID", sessionIDFromUrl);
        setSessionId(sessionIDFromUrl);
      } else {
        const tempSessionID = generateUUID();
        sessionStorage.setItem("sessionID", tempSessionID);
        setSessionId(tempSessionID);
      }
    }
  }, []);
  useEffect(() => {
    let urlParams = new URLSearchParams(window.location.search);
    let campaignid = urlParams.get("campaignid");
    // If not found, check within the hash fragment
    if (!campaignid) {
      urlParams = new URLSearchParams(window.location.hash.substring(1));
      campaignid = urlParams.get("campaignid");
    }
    // Store in sessionStorage if campaignid is found
    if (campaignid) {
      sessionStorage.setItem("campaignId", campaignid);
    }
    // Set campaignId in state
    setCampaignIdHook(campaignid);
  }, []);

  const trackClick = async (requestBody) => {
    try {
      const response = await axios.post(
        "${baseUrl}/api/Blog/trackClickHeatMaps",
        requestBody
      );
      // console.log("Click tracked successfully:", response.data);
      return true;
    } catch (error) {
      console.error("Error tracking click:", error);
      return false;
    }
  };
  // Function to handle button click
  const handleButtonClick_SEO = async (buttonName) => {
    const urlParams = new URLSearchParams(window.location.search);
    const referrer = document.referrer === "" ? "direct" : document.referrer;
    // console.log("Referrer:", referrer);
    const storedTrackingData =
      JSON.parse(sessionStorage.getItem("trackingData")) || {};
    let pageUrl;
    if (buttonName === "Login") {
      pageUrl =
        "https://accounts.bumppy.com/?callback=https://www.anlook.com/get&product_id=1"; // Set to static URL for 'Login'
    } else if (buttonName === "Payment Gateway") {
      pageUrl = "https://payments.bumppy.com"; // Set to static URL for 'Login'
    } else {
      pageUrl = window.location.href; // Keep dynamic for other buttons like 'Get Started'
    }
    const requestBody = {
      // campaignid: urlParams.get("campaignid") || storedTrackingData.campaignid,
      campaignid: campaignIdHook,
      // sessionid: urlParams.get("sessionid"),
      sessionid: sessionID,
      x_cord: "123",
      y_cord: "456",
      element: "Button",
      button_name: buttonName,
      pageurl: pageUrl,
      pagename: "Landing Page",
      product: "Anlook",
      redirection_url: window.location.href,
      utm_source: urlParams.get("utm_source") || storedTrackingData.utm_source,
    };
    const seoTracked = await trackClick(requestBody);

    // Only proceed to login if the SEO tracking was successful

    if (seoTracked) {
      if (buttonName === "Login") {
        login();
      } else if (buttonName === "Get Started" || buttonName === "See Pricing") {
        scrollToPricing();
      }
    }
  };

  // State to handle modal visibility and URL to display

  const [showContentModal, setShowContentModal] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  // Function to handle link clicks and open the modal
  const handleLinkClick = (url) => (e) => {
    e.preventDefault();
    setIframeUrl(url); // Set the URL for the iframe
    setShowContentModal(true); // Show the modal
  };
  // Function to handle modal close
  const handleContentClose = () => setShowContentModal(false);
  // Function to handle modal close
  const buyPlanClick = (plan) => {
    setSelectedPlan(plan);
    setShowModal(true);
  };
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  const toggleSwitch = () => {
    setIsAnnual(!isAnnual);
  };

  const [pricingData, setPricingData] = useState({
    title: `Unlock the Best WhatsApp Business API Pricing with Super `,
    title2: "Affordable Plans & Premium Services!",
    plans: [
      {
        name: "Basic Plan",
        price: "₹2,000",
        gst: "+ GST",
        monthlyFee: "₹2,000",
      },
      {
        name: "Standard Plan",
        price: "₹5,000",
        gst: "+ GST",
        monthlyFee: "₹5,000",
      },
      {
        name: "Gold Plan",
        price: "₹8,000",
        gst: "+ GST",
        monthlyFee: "₹8,000",
      },
    ],
    features: [
      {
        name: "Website",
        values: ["Basic", "Basic+", "Intermediate", "Advanced"],
      },
      {
        name: "Application",
        values: ["Basic", "Basic+", "Intermediate", "Advanced"],
      },
      { name: "Chat Automation", values: [true, true, true, true] },
      { name: "Automated Workflows", values: [true, true, true, true] },
      { name: "Roles & Permissions", values: [true, true, true, true] },
      { name: "SEO/SMO", values: [false, "Basic", "Intermediate", "Advanced"] },
      {
        name: "Shared Team Inbox",
        values: ["Basic", "Basic+", "Intermediate", "Advanced"],
      },
      {
        name: "Unlimited Team Members",
        values: ["Basic", "Basic+", "Intermediate", "Advanced"],
      },
    ],
    footerText: [
      "One Time Cost @5000 + GST",
      "Monthly packages start at ₹2000",
    ],
  });

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const containerRef = useRef(null);
  const updateCarousel = () => {
    if (containerRef.current) {
      const cardWidth =
        containerRef.current.querySelector(".My-Landing-card").offsetWidth;
      containerRef.current.style.transform = `translateX(-${currentIndex * cardWidth
        }px)`;
    }
  };
  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };
  const handleNextClick = () => {
    const totalCards = containerRef.current.children.length;
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, totalCards - 1));
  };
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  useEffect(() => {
    updateCarousel();
  }, [currentIndex, isMobile]);
  // features section
  const [activeFeature, setActiveFeature] = useState(
    "Smart Campaign Management"
  );
  const [isChanging, setIsChanging] = useState(false);
  const features = [
    "Smart Campaign Management",
    "Marketing Performance Analysis",
    "Unified Team Inbox for Efficient Support",
    "Sales & Inventory Management",
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      const currentIndex = features.indexOf(activeFeature);
      const nextIndex = (currentIndex + 1) % features.length;
      setIsChanging(true);
      setTimeout(() => {
        setActiveFeature(features[nextIndex]);
        setIsChanging(false);
      }, 300);
    }, 5000);

    return () => clearInterval(interval);
  }, [activeFeature]);
  const handleButtonClick = (feature) => {
    if (feature !== activeFeature) {
      setIsChanging(true);
      setTimeout(() => {
        setActiveFeature(feature);
        setIsChanging(false);
      }, 300);
    }
  };

  const scrollToPricing = () => {
    if (pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToContactus = () => {
    if (contactusRef.current) {
      contactusRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const scrollToHome = () => {
    if (homeRef.current) {
      homeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [campaignData, setCampaignData] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries; // Get the first entry
        if (entry.isIntersecting) {
          // Get the current URL
          const currentUrl = window.location.href;
          // const basePath = currentUrl.split('?')[0];
          const basePath = currentUrl.split("#")[0].split("?")[0];
          const queryParams = currentUrl.includes("?")
            ? currentUrl.split("?")[1]
            : "";
          // Determine the new hash based on the section in view
          let newHash = "";
          if (entry.target === homeRef.current) {
            newHash = "#home";
          } else if (entry.target === demoVideoRef.current) {
            newHash = "#demoVideo";
          } else if (entry.target === featuresRef.current) {
            newHash = "#features";
          } else if (entry.target === industryRef.current) {
            newHash = "#industry";
          } else if (entry.target === businessgrowthRef.current) {
            newHash = "#businessgrowth";
          } else if (entry.target === contactusRef.current) {
            newHash = "#contactus";
          } else if (entry.target === pricingRef.current) {
            newHash = "#pricing";
          }
          // Set the new URL with the new hash, clearing any previous hash
          if (newHash) {
            const stepName = `${window.location.origin}/get${newHash}`;
            // const timestamp = new Date().toISOString().replace("T", " ").split(".")[0];
            // const timestamp = new Date().toLocaleString("en-GB").replace(",", "");
            // const timestamp = new Date().toISOString().slice(0, 19).replace("T", " ");
            const timestamp = new Date()
              .toLocaleString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
              .replace(",", "")
              .replace(/\//g, "-")
              .replace(" ", " ")
              .slice(0, 19);

            const formattedTimestamp = timestamp
              .split(" ")
              .map((part, index) => {
                if (index === 0) {
                  const dateParts = part.split("-");
                  return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                }
                return part;
              })
              .join(" ");
            setCurrentArray((prevArray) => [
              ...prevArray,
              { stepName, timestamp: formattedTimestamp },
            ]);

            window.history.replaceState(
              null,
              null,
              `${basePath}${newHash}${queryParams ? "?" + queryParams : ""}`
            );
          }
        }
      },
      {
        root: null,
        threshold: 0.5,
      }
    );
    // Observe all relevant sections
    if (homeRef.current) observer.observe(homeRef.current);
    if (demoVideoRef.current) observer.observe(demoVideoRef.current);
    if (featuresRef.current) observer.observe(featuresRef.current);
    if (industryRef.current) observer.observe(industryRef.current);
    if (businessgrowthRef.current) observer.observe(businessgrowthRef.current);
    if (contactusRef.current) observer.observe(contactusRef.current);
    if (pricingRef.current) observer.observe(pricingRef.current);
    // Cleanup observer on component unmount
    return () => {
      if (homeRef.current) observer.unobserve(homeRef.current);
      if (demoVideoRef.current) observer.unobserve(demoVideoRef.current);
      if (featuresRef.current) observer.unobserve(featuresRef.current);
      if (industryRef.current) observer.unobserve(industryRef.current);
      if (businessgrowthRef.current)
        observer.unobserve(businessgrowthRef.current);
      if (contactusRef.current) observer.unobserve(contactusRef.current);
      if (pricingRef.current) observer.unobserve(pricingRef.current);
    };
  }, [campaignIdHook, sessionID]);
  useEffect(() => {
    // Function to call the API
    const callApi = () => {
      if (
        currentArray.length > 0 &&
        sessionID &&
        campaignIdHook &&
        currentArray.some((item) => item.stepName && item.timestamp) // Ensure requests contain valid entries
      ) {
        axios.post("${baseUrl}/api/Blog/InsertNewCampaignLogging", {
          sessionId: sessionID,
          campaignId: campaignIdHook,
          requests: currentArray,
        });
        // Update previousArrayRef to match currentArray after calling API
        previousArrayRef.current = [...currentArray];
        // console.log("API called with currentArray:", currentArray);
      } else {
        // console.log("Skipping API call due to empty payload");
      }
    };
    // Initial API call on page load if criteria are met
    callApi();
    const intervalId = setInterval(() => {
      if (
        JSON.stringify(currentArray) !==
        JSON.stringify(previousArrayRef.current)
      ) {
        callApi();
      }
    }, 2000);
    return () => clearInterval(intervalId);
  }, [currentArray, campaignIdHook, sessionID]);

  const login = () => {
    const productId = "1";
    const callbackUrlBase = `${window.location.origin}/get`;
    const urlParams = new URLSearchParams(window.location.search);
    const campaignid = urlParams.get("campaignid") || "";
    const sessionID = urlParams.get("sessionID") || "";
    const utm_source = urlParams.get("utm_source") || "";
    // const callbackUrl = `${callbackUrlBase}?campaignid=${campaignid}&utm_source=${utm_source}&sessionID=${sessionID}`;
    const callbackUrl = `${callbackUrlBase}`;
    const redirectUrl = `https://accounts.bumppy.com/?callback=${callbackUrl}&product_id=${productId}`;
    window.location.href = redirectUrl;
  };

  const [sessionData, setSessionData] = useState(null);
  const storeUrlParamsInSessionStorage = () => {
    // Check if tracking data is already present in sessionStorage
    const existingData = JSON.parse(sessionStorage.getItem("trackingData"));
    if (existingData) {
      // console.log( "Tracking data already exists in sessionStorage:",existingData);
      return; // If data exists, skip storing new data
    }
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    // Extract the parameters you want to store
    const sessionData = {
      campaignid: urlParams.get("campaignid"),
      sessionid: urlParams.get("sessionid"),
      utm_source: urlParams.get("utm_source"),
      utm_medium: urlParams.get("utm_medium"),
      utm_campaign: urlParams.get("utm_campaign"),
      utm_term: urlParams.get("utm_term"),
      utm_content: urlParams.get("utm_content"),
    };
    sessionStorage.setItem("trackingData", JSON.stringify(sessionData));
    // console.log("Data stored in sessionStorage:", sessionData);
  };

  const getStateAndCountryFromCoordinates = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=10&addressdetails=1`
      );
      const data = await response.json();
      if (data && data.address) {
        const { state, country } = data.address;
        return { state: state || null, country: country || null };
      } else {
        console.error("No address found for the provided coordinates.");
        return { state: null, country: null };
      }
    } catch (err) {
      console.error("An error occurred while fetching the address:", err);
      return { state: null, country: null };
    }
  };
  const fetchLocation = async () => {
    return new Promise((resolve) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            resolve({ latitude, longitude });
          },
          (error) => {
            console.error("Error fetching location:", error);
            resolve({ latitude: null, longitude: null }); // If location is denied
          }
        );
      } else {
        // console.log("Geolocation not supported by the browser.");
        resolve({ latitude: null, longitude: null });
      }
    });
  };
  const trackPageView2 = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    // Get the existing tracking data from session storage if available
    const storedTrackingData =
      JSON.parse(sessionStorage.getItem("trackingData")) || {};
    // Function to get the device type
    const getDeviceType = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        return "Mobile";
      } else if (width > 768 && width <= 1024) {
        return "Tablet";
      } else {
        return "Desktop";
      }
    };
    // Build the tracking data object
    const trackingData = {
      // campaignid: urlParams.get("campaignid") || storedTrackingData.campaignid,
      campaignid: campaignIdHook,
      // sessionid: sessionIDFromURL || storedTrackingData.sessionid,
      sessionid: sessionID,
      page_url: window.location.href,
      utm_source: urlParams.get("utm_source") || storedTrackingData.utm_source,
      utm_medium: urlParams.get("utm_medium") || storedTrackingData.utm_medium,
      utm_campaign:
        urlParams.get("utm_campaign") || storedTrackingData.utm_campaign,
      utm_term: urlParams.get("utm_term") || storedTrackingData.utm_term,
      utm_content:
        urlParams.get("utm_content") || storedTrackingData.utm_content,
      referrer: document.referrer === "" ? "direct" : document.referrer,
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      product: "Anlook",
      device: getDeviceType(),
      country: "location_not_found",
      state: "location_not_found",
    };
    // Store the tracking data in session storage for later use
    // sessionStorage.setItem("trackingData", JSON.stringify(trackingData));
    // Fetch location (latitude, longitude)
    const { latitude, longitude } = await fetchLocation();
    if (latitude && longitude) {
      const location = await getStateAndCountryFromCoordinates(
        latitude,
        longitude
      );
      trackingData.country = location.country;
      trackingData.state = location.state;
    }
    // Send the tracking data to the API
    fetch(`${baseUrl}/api/Blog/insertPageTracking`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(trackingData),
    })
      .then((response) => {
        // console.log("Response from server:", response);
        return response.json();
      })
      // .then((data) => console.log("Page view tracked successfully:", data))
      .catch((error) => console.error("Error tracking page view:", error));
  };
  const [accessToken, setAccessToken] = useState("Not Found");
  const [user, setUser] = useState({});
  useEffect(() => {
    // Store URL parameters in session storage
    storeUrlParamsInSessionStorage();

    // If sessionID exists, proceed with tracking and fetching plans
    if (sessionID) {
      trackPageView2();
      fetchSubscriptionPlans();
    }
  }, [sessionID]);

  const verifyAccessToken = async (token) => {
    try {
      const response = await fetch(`${baseUrl}/api/User/ssoLogin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: token,
          product: "anlook",
        }),
      });
      const data = await response.json();
      // Check if the response code is "00" for success
      if (data.responseCode === "00") {
        setUser(data.response); // Store user data in the state
        // console.log("Access Token Verified:", data.response);
      } else {
        console.error("Access Token Invalid:", data.responseMessage);
      }
    } catch (error) {
      console.error("Error verifying token:", error);
    }
  };
  useEffect(() => {
    // console.log("Component mounted or URL changed"); // Check if useEffect is firing
    // Get the full URL query string
    const queryString = window.location.search;
    // Replace the second `?` with `&` to make the query string valid
    const fixedQueryString = queryString.replace(/\?([^?]+)$/, "&$1");
    // Use the fixed query string with URLSearchParams
    const params = new URLSearchParams(fixedQueryString);
    const token = params.get("accessToken");
    // console.log("Token from URL:", token); // Debug log for token value
    if (token) {
      setAccessToken(token);
      verifyAccessToken(token);
    } else {
      // console.log("No accessToken found in URL");
    }
  }, []);
  const fetchSubscriptionPlans = async () => {
    const url = `${baseUrl}/api/Entitlement/fetchSubscriptionPlans`;
    const requestBody = {
      userid: "",
      countryCode: "IN",
    };

    try {
      const response = await axios.post(url, requestBody, config);
      setPlans(response.data.data); // Assuming the data is in response.data.data
      // setLoading(false);
    } catch (error) {
      // setError('Error fetching subscription plans');
      // setLoading(false);
      console.error("Error fetching subscription plans:", error);
    }
  };
  const logout = () => {
    setUser(null);
  };
  const getUserLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            resolve({ latitude, longitude });
          },
          (error) => {
            reject(error);
          }
        );
      } else {
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  };
  const buyPlanClickAPI = async (planId) => {
    try {
      const location = await getUserLocation();
      const requestBody = {
        userid: user.userid,
        planid: planId,
        latitude: location.latitude.toString(),
        longitude: location.longitude.toString(),
      };
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/buySubscriptionPlan`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        window.location.href = response.data.data.paymentLink;
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      console.error("Error during API call:", error);
      alert("An error occurred. Please try again.");
    }
  };
  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleFormSubmit = (e) => {
    e.preventDefault();
    // console.log("Name:", name);
    // console.log("Phone:", phone);
    // console.log("Message:", message);
    setName("");
    setPhone("");
    setMessage("");
    setShowForm(false);
  };

  const handleCloseClick = () => {
    setShowForm(false);
  };

  const [callBackForm, setCallBackForm] = useState({
    mobile: "",
    email: "",
    name: "",
    message: "",
    source: "",
    callback: "Y",
  });

  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    // Check if the input is for the 'mobile' field
    if (name === "mobile") {
      // Remove non-digit characters and limit input to 10 digits
      const cleanedValue = value.replace(/\D/g, "").slice(0, 10);

      setCallBackForm({
        ...callBackForm,
        [name]: cleanedValue,
      });
    } else {
      // For other form fields, keep the default behavior
      setCallBackForm({
        ...callBackForm,
        [name]: value,
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!callBackForm.name) {
      newErrors.name = "Name is required";
      toast.error("Name is required");
    } else if (!callBackForm.mobile) {
      newErrors.mobile = "Mobile number is required";
      toast.error("Mobile number is required");
    } else if (!/^\d{10}$/.test(callBackForm.mobile)) {
      newErrors.mobile = "Invalid mobile number";
      toast.error("Invalid mobile number");
    } else if (!callBackForm.message) {
      newErrors.message = "Message is required";
      toast.error("Message is required");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const callbackAPI = async () => {
    if (!validateForm()) return;
    try {
      const requestBody = {
        mobile: callBackForm.mobile,
        email: callBackForm.email,
        name: callBackForm.name,
        message: callBackForm.message,
        source: callBackForm.source,
        callback: callBackForm.callback,
      };

      const response = await axios.post(
        `${baseUrl}/api/User/saveLeadMessage`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        // Clear the form after success
        setCallBackForm({
          mobile: "",
          email: "",
          name: "",
          message: "",
          source: "",
          callback: "Y",
        });
      } else {
        toast.error("Failed to edit contact");
      }
    } catch {
      // console.log("");
    }
  };

  const featureContent = {
    "Smart Campaign Management": {
      title: "Smart Campaign Management",
      description: `Easily create and manage one-time or recurring campaigns with our platform. Customize alerts and updates to match your customers’ preferences, ensuring every message is relevant and engaging. Boost interaction and drive more conversions with timely notifications.`,
      subtitle:
        "Track your campaign results effortlessly with our intuitive tools. Gain real-time insights, refine strategies on the go, and maintain seamless communication. Our system is designed to optimize campaign performance and maximize your reach.",
      image: BroadCast,
    },
    "Marketing Performance Analysis": {
      title: "Marketing Performance Analysis",
      description: `Monitor and evaluate your campaigns effortlessly with Anlook. Gain clear insights into what works best, allowing you to fine-tune strategies that boost engagement, conversions and overall business growth. `,
      subtitle:
        "Track ROI, segment audiences, and optimize content with ease. Anlook provides actionable data and tools to transform your marketing efforts into measurable success. Stay ahead in the competitive landscape and make every campaign count.",
      image: Campaign,
    },
    "Unified Team Inbox for Efficient Support": {
      title: "Unified Team Inbox for Efficient Support",
      description: `Handle customer queries instantly with a centralized platform. Our solution automatically routes each message to the right team member, enabling smooth collaboration and faster issue resolution.`,
      subtitle:
        "Track team performance effortlessly using detailed analytics, optimize workflows, and improve conversion rates. This all-inclusive platform helps your business deliver superior service while maintaining operational efficiency.",
      image: Team,
    },
    "Sales & Inventory Management": {
      title: "Sales & Inventory Management",
      description:
        "Transform the way you handle your business sales with a smart WhatsApp storefront. Customers can explore products, place orders, and pay seamlessly, boosting engagement and loyalty. Our complete solution equips you with powerful tools to manage inventory, orders, and customer interactions efficiently.",
      subtitle:
        "Empower your business with a modern approach to customer engagement. Streamline processes, personalize interactions, and drive growth with WhatsApp storefronts your gateway to selling, connecting, and thriving in a competitive market.",
      image: Order,
    },
  };
  useEffect(() => {
    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);
    const script = document.createElement("script");
    script.src = `https://anlook.com/SeoBix/seo_injection.php?webid=56c53e1ff4273fa3746b406c70f5bf9c&url=${encodedUrl}&baseUrl=https%3A%2F%2Fanlook.com`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="gradient-blur">
      <CampaignTracker />
      <CreateSession />
      <ExternalChatBot />
      <ToastContainer />
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        size="lg"
        className="custom-modal"
      >
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title className="modal-title-custom">
            {selectedPlan?.plan_name} Plan
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <div className="custom-pricing-card">
            <div className="custom-plan-info">
              <p className="custom-plan-details d-flex align-items-start justify-content-start">
                <span className="custom-plan-name pe-3 single-line-css text-start mt-1 ">
                  {selectedPlan?.plan_name} Plan :
                </span>
                <span className="custom-plan-price text-start">
                  <span>
                    {selectedPlan?.currency === "INR" ? (
                      <>₹ {Number(selectedPlan?.plan_price).toFixed(0)}</>
                    ) : selectedPlan?.currency === "USD" ? (
                      <>$ {Number(selectedPlan?.plan_price).toFixed(0)}</>
                    ) : (
                      <> {Number(selectedPlan?.plan_price).toFixed(0)}</>
                    )}
                  </span>
                  <span className="ps-1 custom-plan-duration">
                    {selectedPlan?.plan_duration}
                  </span>
                </span>
              </p>
              {selectedPlan?.is_setup_fee_applicable === "Y" ? (
                <>
                  <p className="custom-plan-details ">
                    <span className="custom-plan-name pe-3 single-line-css text-start">
                      Setup Fee :
                    </span>

                    <span className="custom-plan-price">
                      <span>
                        {selectedPlan?.currency === "INR" ? (
                          <>₹ {Number(selectedPlan.setup_fee).toFixed(0)}</>
                        ) : selectedPlan?.currency === "USD" ? (
                          <>$ {Number(selectedPlan.setup_fee).toFixed(0)}</>
                        ) : (
                          <> {Number(selectedPlan.setup_fee).toFixed(0)}</> // Default case
                        )}

                        {/* {selectedPlan.setup_fee} */}
                      </span>
                      <span className="ps-1 custom-plan-duration ">
                        One-Time Fee
                      </span>
                    </span>
                  </p>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="custom-total-cost">
              <h4 className="custom-total-cost-heading">Total Price</h4>
              <p className="custom-total-cost-amount mb-0">
                {selectedPlan?.currency === "INR" ? (
                  <>₹ {Number(selectedPlan?.total_price).toFixed(0)}</>
                ) : selectedPlan?.currency === "USD" ? (
                  <>$ {Number(selectedPlan?.total_price).toFixed(0)}</>
                ) : (
                  <> {Number(selectedPlan?.total_price).toFixed(0)}</> // Default in case currency is unknown
                )}
              </p>
            </div>
          </div>

          {/* Feature List Section */}

          <div className="custom-modal-feature-list-section">
            <h4>Features</h4>
            <ul className="custom-modal-feature-list">
              {selectedPlan?.features
                .filter((feature) => feature.status === "Y") // Filter only features with status 'Y'
                .map((feature, index) => (
                  <li key={index} className="custom-modal-feature-item">
                    {feature.feature_name}
                  </li>
                ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom">
          {!user || !user.username ? (
            <>
              <button
                onClick={() => {
                  handleButtonClick_SEO("Login");
                }}
                className="buy-button"
              >
                Login for Free Trial →
              </button>
            </>
          ) : (
            <button
              onClick={async () => {
                await handleButtonClick_SEO("Payment Gateway");
                buyPlanClickAPI(selectedPlan.id);
              }}
              className="btn btn-primary btn-custom"
            >
              Get Free Trial
            </button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal show={showContentModal} onHide={handleContentClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Content</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Embed the content with an iframe */}
          <iframe
            src={iframeUrl}
            style={{ width: "100%", height: "400px", border: "none" }}
            title="Content Modal"
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="blue-button" onClick={handleContentClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>

      {/* navbar start */}
      <Navbar onLoginClick={onLoginClick} />
      {/* navbar end  */}

      {/* hero section  */}
      <div className="my-landing-p  bg-gred-green-landing">
        <section
          class="My-Landing-engagement-platform py-0 pt-3 center-align"
          id="home"
          ref={homeRef}
        >
          <div className="row col-12 p-0 m-0 d-flex justify-content-center">
            <div class="col-12 col-lg-6   hero-content ">
              <h1 class="hero-title font-size-1 text-start">
                Take Your Business Marketing to the Next Level with Anlook
              </h1>
              <p class="hero-description font-size-3 ">
                Anlook helps businesses connect, engage, and convert customers
                through smarter digital communication. With powerful automation
                and easy-to-use marketing tools, Anlook turns everyday customer
                interactions into growth opportunities.
              </p>
              <ul class="feature-list font-size-3 ">
                <li>Automate messages to engage customers instantly</li>
                <li>Manage all chats from one smart dashboard</li>
                <li>Increase conversions with timely follow-ups</li>
                <li>Deliver personalized messages at scale</li>
                <li>Grow faster with efficient marketing automation</li>
              </ul>
              <div class="cta-buttons">
                <Link
                  to="/get/GetStarted"
                  className=" text-decoration-none Landing-btn"
                  state={{ plan: plans }}
                  onClick={async () => {
                    await handleButtonClick_SEO("Get Started");
                  }}
                >
                  <div className="text-center"> Get Started</div>
                </Link>
                <button
                  className="Landing-btn-2"
                  onClick={() => navigate("/pricing-page")}
                >
                  See Pricing
                </button>
              </div>
            </div>
            <div class=" col-12 col-lg-6  hero-image ">
              <img
                className="img-fluid home-responsive-img "
                src={Women}
                alt=""
              />
            </div>
          </div>
        </section>
      </div>
      {/* hero section end  */}

      {/* built for business */}
      <BuiltForBusiness />
      {/* built fo rbusiness end  */}

      {/* Get started section */}
      <CtaSection />
      {/* get startted section end */}

      {/* relax section */}
      <div className="page-wrap p-5">
        <div className="section-inner">
          <div className="left-box">
            <img src={Women1} alt="marketing" className="main-img" />
          </div>

          <div className="right-box">
            <h1 className="relax-title">
              Instant Billing, Stress Free Service
            </h1>

            <p className="relax-description">
              With Anlook’s smart POS system, you can generate bills in seconds
              and keep your counters moving smoothly. It reduces long queues,
              speeds up service, and ensures accurate billing every time. Your
              staff can focus on serving customers while errors and delays are
              minimized. Enjoy a seamless, stress-free checkout experience that
              keeps your customers happy.
            </p>

            <div className="info-row">
              <div className="info-box">
                <h4>Before</h4>
                <p>
                  Billing was slow and error-prone, with long queues frustrating
                  customers.
                </p>
              </div>

              <div className="info-box">
                <h4>Now </h4>
                <p>
                  Billing is instant and accurate, reducing wait times and
                  errors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* relax section end  */}

      {/* logo scroll */}
      <LogoScroll />
      {/*  end logoScroll */}

      {/* Grow with us start */}
      <div className="stats-wrap">
        <div className="stats-container">
          {/* Left Text */}
          <div className="stats-left">
            <h2>Partnering for Restaurant Success</h2>
          </div>

          {/* Stats */}
          <div className="stats-right">
            <div className="stats-box">
              <div className="stats-icon">
                <img src={grow1} alt="Restaurants" />
              </div>
              <h3>100+</h3>
              <p>Active Restaurants Onboarded</p>
            </div>

            <div className="divider"></div>

            <div className="stats-box">
              <div className="stats-icon">
                <img src={grow2} alt="Restaurants" />
              </div>
              <h3>10000+</h3>
              <p>Daily Food Orders Placed </p>
            </div>

            <div className="divider"></div>

            <div className="stats-box">
              <div className="stats-icon">
                <img src={grow3} alt="Restaurants" />
              </div>
              <h3>6000+</h3>
              <p>Orders Delivered Every Day.</p>
            </div>
          </div>
        </div>
      </div>
      {/* Grow with us end */}

      {/* Price part card  */}
      <div className="pricing-wrap">
        <h2 className="pricing-title">
          Choose the Perfect Plan for Your Growth
        </h2>

        <div className="pricing-cards">
          {plans.slice(0, 3).map((plan, index) => (
            <div
              key={plan.id}
              className={`price-card ${index === 1 ? "highlight" : ""}`}
            >
              <h4 className="plan-name">
                {plan.plan_name}
                {index === 1 && <span className="badge">(Most Popular)</span>}
              </h4>

              <div className="price-row">
                <span className="price">
                  ₹{Number(plan.plan_price).toFixed(0)} /mo
                </span>
              </div>

              <p className="note">No credit card required!</p>

              <p className="plan-desc">{plan.plan_desc}</p>

              <Link
                to="/get/BuyPlan"
                state={{ plan, countryCode: "IN" }}
                className="buy-btn text-decoration-none"
                onClick={() => trackClick("Buy Plan")}
              >
                Buy Now <span>→</span>
              </Link>
            </div>
          ))}
        </div>

        <div className="summary-btn-wrap">
          <Link to="/pricing-page" className="summary-btn text-decoration-none">
            View Plan Summary <span>→</span>
          </Link>
        </div>
      </div>
      {/* price part card end  */}

      {/* features section */}
      <div className="bg-white" id="features" ref={featuresRef}>
        <div className="My-Landing-features ">
          <h1 className="My-Landing-features-title font-size-1">
            Unlock Anlook’s Advanced Tools for Maximum Business Impact
          </h1>
          <div className="main-responsive-flex mb-4 mb-lg-5">
            {features.map((feature) => (
              <button
                key={feature}
                className={`My-Landing-feature-button w-100 ${activeFeature === feature ? "active" : ""
                  }`}
                onClick={() => handleButtonClick(feature)}
              >
                {feature}
              </button>
            ))}
          </div>
          <div className="My-Landing-feature-content">
            <img
              src={featureContent[activeFeature].image}
              className={`My-Landing-feature-image-placeholder ${isChanging ? "changing" : ""
                }`}
              alt="img"
            // style={{ backgroundColor: featureContent[activeFeature].color }}
            ></img>
            <div
              className={`My-Landing-feature-text ${isChanging ? "changing" : ""
                }`}
            >
              <h2>{featureContent[activeFeature].title}</h2>
              <p>{featureContent[activeFeature].description}</p>
              <p>{featureContent[activeFeature].subtitle}</p>
            </div>
          </div>
        </div>
      </div>
      {/* features section end */}

      {/* Get started section */}
      <CtaSection />
      {/* get startted section end */}

      {/* why choose us section  */}
      <div className="bg-white" id="businessgrowth" ref={businessgrowthRef}>
        <div className="anlook-benefits">
          <h2 className="anlook-benefits__title font-size-1">
            Unlock New Opportunities
            <br />
            for Your Business with Anlook
          </h2>
          <div className="anlook-benefits__grid">
            <div className="anlook-benefits__card">
              <div className="anlook-benefits__icon anlook-benefits__icon--megaphone"></div>
              <h3 className="anlook-benefits__card-title font-size-2 ">
                Leverage Anlook’s All in One Tools for Growth.
              </h3>
              <p className="anlook-benefits__card-description font-size-3">
                Attract quality leads with Anlook. Engage customers at every
                stage using smart notifications. Keep them informed with
                automated updates and track campaign results to understand
                performance.
              </p>
            </div>
            <div className="anlook-benefits__card">
              <div className="anlook-benefits__icon anlook-benefits__icon--hand"></div>
              <h3 className="anlook-benefits__card-title font-size-2 ">
                Boost Sales and Drive Conversions via WhatsApp
              </h3>
              <p className="anlook-benefits__card-description font-size-3">
                Turn chats into revenue with Anlook. Guide leads through your
                sales funnel, personalize offers, and encourage upsells. Accept
                payments directly on WhatsApp with secure integrated solutions.
              </p>
            </div>
            <div className="anlook-benefits__card">
              <div className="anlook-benefits__icon anlook-benefits__icon--person"></div>
              <h3 className="anlook-benefits__card-title font-size-2 ">
                Enhance Customer Support and Build Trust
              </h3>
              <p className="anlook-benefits__card-description font-size-3">
                Provide seamless support with Anlook’s 24×7 system. Use a single
                contact for all queries and automate responses for high-volume
                conversations. Monitor interactions to maintain excellent
                service standards.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* qr code section start */}
      <div className="demo-wrap">
        <div className="demo-container">
          <div className="demo-left">
            <span className="demo-tag">LIVE DEMO</span>

            <h2 className="demo-title">Try WhatsApp Ordering Instantly</h2>
            <p className="demo-text">
              Scan the QR code to explore the menu directly on WhatsApp. No
              downloads needed—simply place an order and experience how
              effortless ordering can be.
            </p>
          </div>

          {/* Right QR */}
          <div className="demo-right">
            <div className="qr-box">
              <img src={qrImage} alt="WhatsApp Ordering QR" />
            </div>
          </div>
        </div>
      </div>
      {/* qr section end  */}

      {/* Pricing details start */}
      <PricingSection />
      {/* pricing details end */}
      {/* faq Section Start */}
      <FaqSection />
      {/* faqSection end */}

      {/* Contact section start */}
      <ContactSection />
      {/* contact section end */}

      {/* footer section */}
      <Footer />
      {/* Footer section ending */}
    </div>
  );
}
export default MyLanding;